import { render } from "./StockPage.vue?vue&type=template&id=3f6680b5&ts=true"
import script from "./StockPage.vue?vue&type=script&lang=ts"
export * from "./StockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__